import { render, staticRenderFns } from "./Leases.vue?vue&type=template&id=3572f57d&"
import script from "./Leases.vue?vue&type=script&lang=js&"
export * from "./Leases.vue?vue&type=script&lang=js&"
import style0 from "./Leases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports